<template>
    <div >
        <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="定制流水号" style="width: 50%;">
                            <el-input v-model="q.reformId" placeholder="多改制模糊查询请用空格或分号分隔" :clearable="true"></el-input>
                        </el-form-item>

                        <el-form-item label="经销商名称/编码">
                            <el-input v-model="q.agentName" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="物料编码">
                            <el-input v-model="q.materialCode" :clearable="true"></el-input>
                        </el-form-item>
                    </div>
                    <el-collapse-transition>
                        <div v-show="isScreen">
                            <div class="h-thirdColumn w-newColumn">
                                <el-form-item label="状态" prop="status">
                                    <brselect category="reform_status" :v="q.status"
                                              v-model="q.status" :multiple="true" clearable></brselect>
                                </el-form-item>
                                <el-form-item label="链群名称" prop="lianqun">
                                    <brselect clearable category="xsyb_lianqun" :v="q.lianqun"
                                              v-model="q.lianqun"></brselect>
                                </el-form-item>
                                <el-form-item label="改制类型">
                                    <el-select v-model="q.reformType"
                                               placeholder="请选择"
                                               clearable>
                                        <el-option label="生产改制" value="0"></el-option>
                                        <el-option label="库存改制" value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="物料工位" prop="materialStation">
                                    <brselect category="material_station" :v="q.materialStation"
                                              v-model="q.materialStation" :multiple="true" :collapse-tags="true" clearable></brselect>
                                </el-form-item>
                            </div>
                            <div class="h-thirdColumn w-newColumn">
                                <el-form-item label="创建时间" class="timeselect" style="width: 50%;">
                                    <el-date-picker
                                            placeholder="请选择"
                                            v-model="q.cdatebegin"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd" >
                                    </el-date-picker>
                                    <span class="w-time-to">至</span>
                                    <el-date-picker
                                            placeholder="请选择"
                                            v-model="q.cdateend"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd" >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="审批通过时间" class="timeselect" style="width: 50%;">
                                    <el-date-picker
                                            placeholder="请选择"
                                            v-model="q.spbegin"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd" >
                                    </el-date-picker>
                                    <span class="w-time-to">至</span>
                                    <el-date-picker
                                            placeholder="请选择"
                                            v-model="q.spend"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd" >
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                        </div>
                    </el-collapse-transition>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
                    </div>
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                        <el-button
                                class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                @click="createdReform" >新增改制订单
                        </el-button>
                    </div>
                </div>
            </div>

            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        @selection-change="handleSelectionChange"
                        stripe
                        border
                        style="width: 100%">

                    <el-table-column
                            type="selection"
                            fixed
                            width="40">
                    </el-table-column>
                    <el-table-column
                            type="index"
                            width="40"
                            label="序号"
                            fixed >
                    </el-table-column>
                    <el-table-column
                            prop="reformId"
                            label="定制流水号"
                            :show-overflow-tooltip="true"
                            width="230">
                    </el-table-column>
                    <el-table-column
                            prop="agentCode"
                            label="经销商编码"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="agentName"
                            label="经销商名称"
                            :show-overflow-tooltip="true"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="areaName"
                            label="区域名称"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            label="状态"
                            prop="status"
                            width="110">
                        <template slot-scope="scope">
                            {{scope.row.status|dictname('reform_status')}}
                        </template>
                    </el-table-column>

                    <el-table-column
                            prop="materialCode"
                            label="物料编码"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="materialName"
                            label="物料名称"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="lianqunName"
                            label="链群名称"
                            width="110">
                    </el-table-column>


                    <el-table-column
                            prop="number"
                            label="数量"
                            width="110">
                    </el-table-column>
                   <!-- <el-table-column
                            prop="specificDivisions"
                            label="改制大类"
                            :show-overflow-tooltip="true"
                            width="210">
                    </el-table-column>
                    <el-table-column
                            prop="specificReqs"
                            label="改制描述"
                            :show-overflow-tooltip="true"
                            width="210">
                    </el-table-column>-->
                    <el-table-column
                            prop="oneLId"
                            label="产品大类编码"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="oneLName"
                            label="产品大类名称"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="reformPrice"
                            label="定制加价（单台）"
                            width="110">
                    </el-table-column>

                    <el-table-column
                            prop="reformType"
                            label="改制类型"
                            width="110">
                        <template scope="scope">
                            <span v-if="scope.row.reformType == '0'">生产改制</span>
                            <span v-if="scope.row.reformType == '1'">库存改制</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="isUsed"
                            label="是否使用"
                            width="80">
                        <template scope="scope">
                            <span v-if="scope.row.isUsed == '0'">否</span>
                            <span v-if="scope.row.isUsed == '1'">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="specialId"
                            label="特价版本号"
                            width="140">
                    </el-table-column>

                    <el-table-column
                            prop="produceTime"
                            label="生产日期"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            label="物料工位"
                            prop="materialStation"
                            :show-overflow-tooltip="true"
                            width="150">
                        <template slot-scope="scope">
                            {{scope.row.materialStation|dictname('material_station')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="specificText"
                            label="改制目录"
                            :show-overflow-tooltip="true"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            label="备注"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="outputValue"
                            label="产值(元)"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="standardTable"
                            label="标准台"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="dbrname"
                            label="下一审批人"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="lastSptgTime"
                            :show-overflow-tooltip="true"
                            label="审核通过时间"
                            width="140">
                    </el-table-column>
                    <el-table-column
                            prop="cucode"
                            label="创建人编码"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="cuname"
                            label="创建人名称"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="cdate"
                            :formatter="formatDate"
                            label="创建时间"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="lucode"
                            label="修改人编码"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="ldate"
                            :formatter="formatDate"
                            label="最后修改时间"
                            width="110">
                    </el-table-column>


                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="280" >
                        <template slot-scope="scope">
                            <div v-if="scope.row.status == '0' || scope.row.status == '3'|| scope.row.status == '-1'" style="text-align: left;">
                                <el-button
                                        type="text"
                                        size="small"
                                        @click="toChange(scope.row)"
                                        class="h-tableLink h-btn"
                                        v-if="_user.usercode == scope.row.cucode && !scope.row.score && scope.row.status == '-1'" >
                                    编辑
                                </el-button>
                                <el-button
                                        type="text"
                                        size="small"
                                        @click="toChange(scope.row)"
                                        class="h-tableLink h-btn"
                                        v-if="_user.usercode == scope.row.cucode && scope.row.status == '-1'" >
                                    重新提交
                                </el-button>
                                <el-button
                                        v-if="scope.row.status==3 || scope.row.status == '-1'"
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="printDetail(scope.row.id)">
                                    导出明细
                                </el-button>
                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        @click="doDelete(scope.row)">删除
                                </el-button>
                                <el-button v-if="scope.row.instid"
                                           size="small" class="h-tableLink h-btn"
                                           @click="genzongLiuch(scope.row.instid)">
                                    跟踪
                                </el-button>

                            </div>
                            <div v-else style="text-align: left;">
                                <el-button v-if="scope.row.instid"
                                           size="small" class="h-tableLink h-btn"
                                           @click="genzongLiuch(scope.row.instid)">
                                    跟踪
                                </el-button>
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="toSee(scope.row)">
                                    查看
                                </el-button>
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="printDetail(scope.row.id)">
                                    导出明细
                                </el-button>
                                <el-button
                                        size="small" v-if="scope.row.status == 1 && _user.usercode == scope.row.cucode" class="h-tableLink h-btn"
                                        @click=" reformCh(scope.row)">撤回
                                </el-button>
                                <el-button
                                        size="small" v-if="cancelFlag && scope.row.status == '2'" class="h-tableLink h-btn"
                                        @click=" reformZf(scope.row)">作废
                                </el-button>
                            </div>
                        </template>


                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="padding: 0.1rem 0.20rem"  @click="downloadExcelDetailBatch">批量导出明细</el-button>
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel">批量导出
                        </el-button>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query" />
                    </div>
                </div>

            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        <el-dialog :close-on-click-modal="false" title="改制单撤回" :visible.sync="chehuidialogFormVisible">
            <el-form :model="zf">
                <el-form-item label="撤回原因" :label-width="100">
                    <el-input type="textarea" v-model="zf.deleteReason" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="withdraw">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="改制单作废" :visible.sync="zuofeidialogFormVisible">
            <el-form :model="zf">
                <el-form-item label="作废原因" :label-width="100">
                    <el-input type="textarea" v-model="zf.deleteReason" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="cancelReform">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

    import reformService from "../../../api/reform/reformService.js";
    import updownfile from "../../../utils/updownfile";
    import ss from "../../../api/SystemService";
    import engTable from "../../../api/dingd/ProductEngTable";
    export default {
        components: {},
        data() {
            return {
                //查询属性
                q: {
                    agentCode:null,
                    agentName:null,
                    materialCode:null,
                    materialName:null,
                    reformId:null,
                    status:null,
                    lianqun:null,
                    reformType:null,
                    materialStation:null,
                    cdatebegin:null,
                    cdateend:null,
                    spbegin:null,
                    spend:null,
                    id:null,
                    delflag:1,
                    pageSize:10,
                    pageNo:1,
                    total:0,
                },
                //表单
                f:{
                    agentCode:null, // 经销商编码
                    agentName:null, // 经销商名称
                    areaCode:null, // 区域编码
                    areaName:null, // 区域名称
                    lianqun:null, // 链群`
                    lianqunName:null, // 链群名称
                    materialCode:null, // 物料编码
                    materialName:null, // 物料名称
                    number:null, // 数量
                    specificIds:null, // 改制大id
                    specificDivisions:null,//改制大类
                    specificReqs:null, // 改制大描述
                    oneLId:null, // 产品大类编码
                    oneLName:null, // 产品大类名称
                    reformPrice:null, // 定制加价（单台）
                    currency:null, // 币种
                    reformId:null, // 定制编号
                    reformType:null, // 0生产改制1库存改制
                    marketForecastId:null, // 市场预测单号
                    produceTime:null, // 生产日期
                    isUsed:null, // 1：已使用，0：没使用
                    remark:null, // 备注
                    instid:null, // 流程id
                    cucode:null, // 创建人编码
                    cuname:null, // 创建人名称
                    lucode:null, // 修改人编码
                    ldate:null, // 最后修改时间
                    cdate:null,//创建日期
                    lastSptgTime:null,//审核通过时间

                },
                tableSelectedList:[],
                //table列表
                tableData: [],
                showhistory: null,
                // 展开折叠筛选
                isScreen: false,
                closeScreen: require("@/assets/images/pimg/closeallic.png"),
                drawScreen: require("@/assets/images/pimg/dobleArr.png"),
                chehuidialogFormVisible:false,
                zuofeidialogFormVisible:false,

                cancelFlag:false,
                zf:{
                    id:null,//主键id
                    deleteReason:null,//删除原因
                },
            }
        },
        created() {
            this.query();
            if (this.$store.getters.hasRole('swyl_admin') || this.$store.getters.hasRole('swyl_shengchan')) {
                this.cancelFlag = true;
            }
        },
        methods: {
            query() {
                reformService.selecPage(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            handleFilter() {
                this.query();
            },

            handleSelectionChange(lists){
                this.tableSelectedList = lists;
            },
            resetData(){
                var pageSize=this.q.pageSize;
                var pageNo=this.q.pageNo;
                var total=this.q.total;
                this.q= {
                    agentName:null,
                    agentCode:null,
                    id:null,
                    materialCode:null,
                    materialName:null,
                    pageSize: pageSize,
                    pageNo: pageNo,
                    total:total,
                }
            },
            //新增周会议纪要
            createdReform() {
                this.$router.push({path: "/chanp/addReform"});
            },
            //查看按钮功能
            toSee(q) {
                this.$router.push({path: '/chanp/seeReform',query: {ywid: q.id}});
            },

            //修改
            toChange(q) {
                this.$router.push({path: "/chanp/addReform", query: {ywid: q.id}});
            },
            //导出明细
            printDetail(x) {
                reformService.checkDownload(x).then(rd => {
                    if(rd.f){
                        updownfile.down('/api/swyl/v1/reform/reformMain/downloadExcelDetail',{id:x},"get");
                    }
                })
            },
            //删除
            doDelete(row){
                this.$msg.confirm("确认删除?", () => {
                    reformService.deleteById(row.id).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                });

            },
            //撤回
            withdraw(){
                var data = {};
                data = this.zf;
                this.$msg.confirm("确认撤回?", () => {
                    reformService.reformWidthdraw(data).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.cancel();
                        this.query();
                    });
                });

            },
            //作废
            cancelReform(){
                var data = {};
                data = this.zf;
                this.$msg.confirm("确认作废?", () => {
                    reformService.reformCancel(data).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.cancel();
                        this.query();
                    });
                });

            },
            //跟踪
            genzongLiuch(instid) {
                this.instid = instid;

                this.showhistory = true;
            },

            //批量导出箱单发票Excel
            downloadExcelDetailBatch() {
                var flag1 = false
                this.tableSelectedList.forEach((item, index) => {
                    if(item.status != 2){
                        flag1 = true;
                        return;
                    }
                })

                if(flag1){
                    this.$msg.msge("审核通过后的正常订单才能导出明细,请重新选择!");
                    return;
                }
                var strids = _.join(_.map(this.tableSelectedList,"id"),",");
                this.$msg.confirm("确认批量导出明细?", () => {
                    updownfile.down('/api/swyl/v1/reform/reformMain/downloadExcelDetailBatch',{ids:strids},"post");

                });
            },
            // 展开折叠
            collapseChange() {
                this.isScreen = !this.isScreen;
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            exportExcel(){
                var strids = _.join(_.map(this.tableSelectedList,"id"),",");

                var form = this.q;

                if (strids == '') {
                    form = _.clone(this.q);
                }
                form.strids = strids;
                updownfile.down("api/swyl/v1/reform/reformMain/downloadExcel", this.q, "post");
            },
            reformCh(v){
                this.zf.id = v.id;
                this.chehuidialogFormVisible = true;
            },
            reformZf(v){
                this.zf.id = v.id;
                this.zuofeidialogFormVisible = true;
            },
            cancel(){
                this.chehuidialogFormVisible = false;
                this.zuofeidialogFormVisible = false;
                this.zf = {
                    id:null,
                    deleteReason:null,
                };
            },
        }
    }
</script>
